export default "__VITE_ASSET__Dcf9ZcIl__"